import { useSelector } from "react-redux";

export const useHeaderContactInfos = () => {
  const Monitoring = useSelector((state) => state.monitoring);
  const ChatSimult = useSelector((state) => state.chatsimult);
  const InfoUsers = useSelector((state) => state.informationusers);
  const MonitoringSimult = useSelector((state) => state.monitoringsimult);
  const ClientUserMonitors = useSelector((state) => state.clientusermonitors);

  return {
    ChatSimult,
    InfoUsers,
    MonitoringSimult,
    ClientUserMonitors,
    Monitoring,
  };
};
